import { useState, useCallback, useEffect } from 'react';
import { COLORS } from '../../../game/data/colors';
import { IMAGES } from '../../../game/data/images';
import { CompetitionTripData } from '../../../game/data.type';
export const TRIP_LINE_WIDTH = 4;

export const CompetitionTrip: React.FC<{ tripData: CompetitionTripData }> = ({ tripData }) => {
  const [lineStyle, setLineStyle] = useState({ width: '0px', transform: '', top: '0px', left: '0px', transformOrigin: '0 0' });

  const updateLineStyle = useCallback(() => {
    const div1 = document.getElementById(`airport${tripData.fromAirport.slug}`);
    const div2 = document.getElementById(`airport${tripData.toAirport.slug}`);

    if (div1 && div2) {
      const rect1 = div1.getBoundingClientRect();
      const rect2 = div2.getBoundingClientRect();

      const x1 = rect1.left + rect1.width / 2;
      const y1 = rect1.top + rect1.height / 2;
      const x2 = rect2.left + rect2.width / 2;
      const y2 = rect2.top + rect2.height / 2;

      const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
      const angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);

      setLineStyle({
        width: `${distance}px`,
        transform: `translateY(-${TRIP_LINE_WIDTH / 2}px) rotate(${angle}deg)`,
        top: `${y1}px`,
        left: `${x1}px`,
        transformOrigin: '0 0',
      });
    }
  }, [tripData.fromAirport.slug, tripData.toAirport.slug]);

  useEffect(() => {
    updateLineStyle();
    window.addEventListener('resize', updateLineStyle);
    return () => {
      window.removeEventListener('resize', updateLineStyle);
    };
  }, [updateLineStyle]);

  return (
    <div
      style={{
        position: 'fixed',
        height: 4,
        ...lineStyle,
      }}
    >
      <img
        src={IMAGES.AIRPLANES.white}
        alt={'airplane'}
        style={{
          width: 24,
          top: TRIP_LINE_WIDTH / 2,
          position: 'absolute',
          opacity: 0.15,
          animation: `moveairplane ${tripData.lengthMs}ms linear`,
          transform: `translate(-50%, -50%) rotate(90deg)`,
        }}
      />
    </div>
  );
};
